import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { OperatingMonth } from "../../models/operating-month.model";

export namespace OperatingMonthActions {
  @logDispatcher
  export class GetOperatingMonth {
    static readonly type = '[OperatingMonth] GetOperatingMonth';
    constructor() {}
  }

  @logDispatcher
  export class GetOperatingMonthSuccess {
    static readonly type = '[OperatingMonth] GetOperatingMonthSuccess';
    constructor(public operatingMonth: OperatingMonth) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[OperatingMonth] Error';
    constructor(public error: any) {}
  }
}
